import { Injectable } from "@angular/core";
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from "@angular/forms";
import { FormlyFieldConfig, FormlyFormOptions } from "@ngx-formly/core";
import { BehaviorSubject } from "rxjs";
import { environment } from "src/environments/environment";
import { TabType } from "../../modelau/ui/tab-type";
import { IaithService } from "../iaith/iaith.service";

@Injectable({
  providedIn: "root",
})
export class CwestiwnService {
  // Fforms unigol
  public form: UntypedFormGroup = new UntypedFormGroup({}, { updateOn: "blur" });
  public fields: FormlyFieldConfig[];
  public options: FormlyFormOptions = {
    formState: {
      errors$: new BehaviorSubject<any>(null),
    },
  };
  // Fforms mewn tabs
  public tabs: TabType[] = null;
  public formArray: UntypedFormArray = null;
  public optionsArray: FormlyFormOptions[] = null;

  constructor(private iaithService: IaithService) {}

  setioGwallau(errors: { [key: string]: string }): void {
    this.options.formState.errors$.next(errors);

    Object.entries(errors).forEach(([key, value]) => {
      if (key) {
        let cywiroKey = key[0].toLowerCase() + key.substring(1);
        let cyfieithuNeges = this.iaithService.nolTestun(value)[value];

        const formControl = this.form.get(cywiroKey);

        formControl.setErrors({ gwall: cyfieithuNeges });
      }
    });
  }

  setioGwallauTabs(errors: { [key: string]: string }): void {
    this.options.formState.errors$.next(errors);

    Object.entries(errors).forEach(([key, value]) => {
      if (key) {
        let cywiroKey = key[0].toLowerCase() + key.substring(1);
        let cyfieithuNeges = this.iaithService.nolTestun(value)[value];
        let formControl: AbstractControl = null;

        //formControl = this.formArray.controls.filter(function (item) { console.log(item.get(cywiroKey)); return item.get(cywiroKey); })[0] || null;

        // loop'io y tabs
        this.formArray.controls.forEach((element) => {
          var temp = element.get(cywiroKey);

          if (temp) {
            formControl = temp;
          }
        });

        if (formControl) {
          formControl.setErrors({ gwall: cyfieithuNeges });
        } else {
          //console.log('formControl is null');
        }
      }
    });
  }

  creuFlex(config: FormlyFieldConfig[]): FormlyFieldConfig {
    return {
      type: "flex-layout",
      templateOptions: {
        fxLayout: environment.flex.fxLayout,
        fxLayoutAlign: environment.flex.fxLayoutAlign,
        fxLayoutGap: environment.flex.fxLayoutGap,
      },
      fieldGroup: config,
    };
  }

  creuForm(config: FormlyFieldConfig[]): FormlyFieldConfig {
    return {
      type: "form-layout",
      templateOptions: {
        fxLayout: environment.flex.fxLayout,
        fxLayoutAlign: environment.flex.fxLayoutAlign,
        fxLayoutGap: environment.flex.fxLayoutGap,
      },
      fieldGroup: config,
    };
  }

  creuMaesTeiars(config: FormlyFieldConfig[]): FormlyFieldConfig {
    return {
      type: "maes-diogelwch-teiar-flex",
      templateOptions: {
        fxLayout: "row",
        fxLayoutAlign: "start",
      },
      fieldGroup: config,
    };
  }

  creuMaesTeiar(config: FormlyFieldConfig[]): FormlyFieldConfig {
    return {
      type: "maes-diogelwch-teiar-unigol",
      templateOptions: {
        fxLayout: environment.flex.fxLayout,
        fxLayoutAlign: environment.flex.fxLayoutAlign,
      },
      fieldGroup: config,
    };
  }
}
